import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Search, Sparkles, MapPin, Heart, BookMarked } from 'lucide-react';

const destinations = ['全部', '国内', '亚洲', '欧洲', '美洲', '小众'];
const tags = ['美食', '人文', '自然', '冒险', '亲子', '情侣'];

const guides = [
  { id: 1, title: '川西小环线深度自驾攻略', dest: '四川', summary: '五天四晚，穿越雪山草原，感受藏地风情...', author: '自驾达人', likes: 1200, collects: 340, ai: false },
  { id: 2, title: '京都红叶季赏枫指南', dest: '日本', summary: '最佳赏枫时间、路线规划、拍照点位全攻略...', author: '樱花妹', likes: 980, collects: 210, ai: true },
  { id: 3, title: '新疆南疆人文之旅', dest: '新疆', summary: '喀什古城、塔克拉玛干沙漠、帕米尔高原...', author: '摄影师李', likes: 1500, collects: 450, ai: false },
];

const Guides = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="bg-gradient-to-r from-primary to-accent rounded-card p-8 text-white mb-8 shadow-card relative overflow-hidden">
          <div className="relative z-10">
            <h1 className="text-3xl font-bold mb-4">旅行攻略</h1>
            <div className="flex gap-2 max-w-md">
              <Input placeholder="搜索目的地或攻略关键词" className="rounded-btn bg-white text-text-primary border-0" />
              <Button className="bg-white text-primary hover:bg-white/90 rounded-btn px-6"><Search className="w-4 h-4" /></Button>
            </div>
          </div>
        </div>

        <Card className="border-0 shadow-card rounded-card bg-gradient-to-r from-primary to-accent text-white mb-8">
          <CardContent className="p-6 flex flex-col md:flex-row items-center gap-4">
            <div className="flex-1">
              <h2 className="text-xl font-bold mb-1 flex items-center gap-2"><Sparkles className="w-5 h-5" /> AI一键生成攻略</h2>
              <p className="text-sm opacity-90">输入目的地和天数，AI为你定制专属行程</p>
            </div>
            <div className="flex gap-2">
              <Input placeholder="目的地" className="rounded-smwidget bg-white/20 border-white/30 text-white placeholder:text-white/70" />
              <Input placeholder="天数" type="number" className="rounded-smwidget bg-white/20 border-white/30 text-white placeholder:text-white/70 w-20" />
              <Button className="bg-white text-primary hover:bg-white/90 rounded-btn">立即生成</Button>
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-wrap gap-2 mb-6">
          {destinations.map((d) => <Badge key={d} variant="secondary" className="cursor-pointer rounded-full bg-white text-text-secondary hover:bg-primary hover:text-white transition-colors">{d}</Badge>)}
        </div>
        <div className="flex flex-wrap gap-2 mb-8">
          {tags.map((t) => <Badge key={t} variant="outline" className="cursor-pointer rounded-full border-[#E8E4DF] text-text-secondary hover:border-primary hover:text-primary transition-colors">{t}</Badge>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {guides.map((g) => (
            <Card key={g.id} className="border-0 shadow-card rounded-card bg-white overflow-hidden hover:shadow-hover hover:-translate-y-1 transition-all cursor-pointer" onClick={() => navigate(`/guide/${g.id}`)}>
              <div className="h-40 bg-gradient-to-br from-primary/20 to-accent/20 relative">
                <img src={`https://picsum.photos/seed/${g.dest}-scenery/600/400`} alt="" className="w-full h-full mx-auto object-cover" />
                {g.ai && <span className="absolute top-3 left-3 bg-primary text-white text-xs px-2 py-1 rounded-full">AI生成</span>}
              </div>
              <CardContent className="p-4">
                <h3 className="font-semibold text-text-primary line-clamp-1 mb-2">{g.title}</h3>
                <p className="text-sm text-text-secondary line-clamp-2 mb-3">{g.summary}</p>
                <div className="flex items-center justify-between text-xs text-text-tertiary">
                  <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {g.dest}</span>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1"><Heart className="w-3 h-3" /> {g.likes}</span>
                    <span className="flex items-center gap-1"><BookMarked className="w-3 h-3" /> {g.collects}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-8">
          <Button variant="outline" className="rounded-btn border-[#E8E4DF]">加载更多</Button>
        </div>
      </div>
    </div>
  );
};

export default Guides;
